/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import PropTypes from "prop-types";

import {
  handleOtpVerification,
  handleResendOtp
} from "api";
import {
  triggerToast,
  handleFuryApiError
} from "helpers";

import OtpVerification from "./OtpVerification";

const propTypes = {
  authRes: PropTypes.object,
  rsessionId: PropTypes.string,
  setAuthRes: PropTypes.func,
  setIsLoading: PropTypes.func,
  setUserStep: PropTypes.func,
  userData: PropTypes.object
};

const OtpVerificationContainer = ({
  authRes,
  setAuthRes,
  rsessionId,
  setUserStep,
  setIsLoading,
  userData
}) => {
  const [isVerifying, setIsVerifying] = useState(false);

  const handleOtp = async (e) => {
    const otp = e.target.value;
    if (otp.length >= 6) {
      setIsVerifying(true);
      e.target.blur();
      setIsLoading(true);

      try {
        const payload = {};
        payload["user_id"] = authRes?.userId;
        payload["existing_user"] = authRes?.existingUser;
        payload["otp"] = otp;
        const res = await handleOtpVerification(payload, rsessionId);
        if (res?.data) {
          setAuthRes(res.data);
          if (res.data.nextStep === "TWOFA_SETUP" || res.data.nextStep === "TWOFA_INPUT") {
            setUserStep(3);
          }
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (err) {
        handleFuryApiError(err);
        setIsLoading(false);
      }
    }
  };

  const handleResend = async () => {
    setIsLoading(true);
    try {
      const payload = {};
      payload["user_id"] = authRes?.userId;
      payload["existing_user"] = authRes?.existingUser;
      const res = await handleResendOtp(payload, rsessionId);
      if (res?.data) {
        triggerToast("OTP Sent Successfully", "success");
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      triggerToast("Something went wrong, try again later!", "error");
      setIsLoading(false);
    }
  };

  return (
    <OtpVerification
      authRes={authRes}
      handleOtp={handleOtp}
      handleResend={handleResend}
      isVerifying={isVerifying}
      userData={userData}
    />
  );
};

OtpVerificationContainer.propTypes = propTypes;

export default OtpVerificationContainer;
